import { curry, getOr } from 'lodash/fp';
import { Feature } from '../../../../types/CompanyDtos';
import { CurrentUserDto } from '../../../../types/UserDtos';
import { getCurrentUser } from '../CurrentUser';
import { getHasLocalOverride, LocalOverride } from './localOverrides';

const hasLocalOverride = getHasLocalOverride();

export const isFeatureEnabledForUser = curry((feature: Feature, currentUser: CurrentUserDto) => {
    const enabledFeatures = getOr({}, 'company.enabledFeatures', currentUser);
    // check for user specific access here too
    return !!enabledFeatures[feature] || hasLocalOverride(feature as LocalOverride);
});

const isFeatureEnabledForUserIgnoreLocalOverride = curry((feature: Feature, currentUser: CurrentUserDto) => {
    const enabledFeatures = getOr({}, 'company.enabledFeatures', currentUser);
    return !!enabledFeatures[feature];
});

export const isFeatureRestrictedForUser = curry((feature: Feature, currentUser: CurrentUserDto) => {
    const enabledFeatures = getOr({}, 'company.restricted', currentUser);
    // check for user specific access here too
    return !!enabledFeatures[feature];
});

export const isFeatureEnabled = (feature: Feature) => isFeatureEnabledForUser(feature, getCurrentUser() || {});
export const isFeatureEnabledIgnoreLocalOverride = (feature: Feature) =>
    isFeatureEnabledForUserIgnoreLocalOverride(feature, getCurrentUser() || {});

export const areFeaturesEnabled = (...features: Feature[]) =>
    features.every(f => isFeatureEnabledForUser(f, getCurrentUser() || {}));

export const isFeatureRestricted = (feature: Feature) => isFeatureRestrictedForUser(feature, getCurrentUser());

export const isEffectivelyRestricted = (feature: Feature) =>
    getCurrentUser().company.restrictedFeatures.includes(feature) && !isFeatureEnabled(feature);
